import { Checkbox as PrimeCheckbox } from "primereact/checkbox";

interface ICheckboxProps {
    id: string;
    name: string;
    checked?: boolean;
    disabled?: boolean;
    label: string;
    onChange: (value: boolean) => void;
}

export default function Checkbox({ id, name, label, checked = false, disabled, onChange }: ICheckboxProps) {
    return (
        <div className="flex align-items-center my-2">
            <PrimeCheckbox 
                id={id}
                name={name} 
                type="checkbox"
                disabled={disabled}
                checked={checked}
                onChange={(e) => {
                    onChange(e.checked ?? false);
                }}
            />
            <label htmlFor={id} className="ml-2">{label}</label>
        </div>
    )
}
